import { QueryResult } from 'react-query';
import { callApi, Controller, useApi, UseApiOptions } from './useApi';
// eslint-disable-next-line import/no-cycle
import { Kunde } from './kunde';
import { TerminAttachment } from './terminAttachment';

export interface Termin {
    zfKaNr?: number;
    kNr: number;
    kaNr?: number;
    datumVon: string;
    zeitVon: number;
    datumBis: string;
    zeitBis: number;
    terminArt: string;
    userKz: string;
    terminOrt: string;
    terminBetreff: string;
    terminText: string;
    terminStatus: boolean;
    prodInfo: boolean;
    mailKd: boolean;
    mailKdBem: boolean;
    mailPdf: boolean;
    artikelGruppeNr: number;
    artikelNr: string;
    posText: string;
    posEinh: string;
    posMenge: number;
    syncOutlook: boolean;
    kaName: string;
    anlageDat?: string;
    anlageUhr?: number;
    anlageUser?: string;
    updDat?: string;
    updUhr?: number;
    updUser?: string;
    kunde?: Kunde;
    terminAttachmentList?: TerminAttachment[];
}

export interface TerminFilter {
    zfKaNr?: number;
    kNr?: number;
    searchText?: string;
    userKz?: string;
    terminStatus?: number;
    terminArt?: string;
    onlyDue?: boolean;
    kNrArtikelGruppeNrAndArtikelNrList?: string[];
    withKunde?: boolean;
    withTerminAttachments?: boolean;
    includeArchiv?: boolean;
    maxRows?: number;
    sortAsc?: boolean;
}

export function useTermin(filter: TerminFilter, apiOptions?: UseApiOptions<Termin>): QueryResult<Termin> {
    return useApi<Termin>(Controller.termin + '/one', { filter }, apiOptions);
}

export function useTerminList(filter: TerminFilter, apiOptions?: UseApiOptions<Termin[]>): QueryResult<Termin[]> {
    return useApi<Termin[]>(Controller.termin + '/list', { filter }, apiOptions);
}

export async function addTermin(termin: Termin): Promise<void> {
    return callApi<void>(Controller.termin + '/add', { termin });
}

export async function updateTermin(termin: Termin): Promise<void> {
    return callApi<void>(Controller.termin + '/update', { termin });
}
